import { render, staticRenderFns } from "./SystemTags.vue?vue&type=template&id=5ce06c3e&scoped=true"
import script from "./SystemTags.vue?vue&type=script&lang=ts"
export * from "./SystemTags.vue?vue&type=script&lang=ts"
import style0 from "./SystemTags.vue?vue&type=style&index=0&id=5ce06c3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce06c3e",
  null
  
)

export default component.exports